<template>
  <b-modal ref="modal" @close="close()" :class="'modal-' + (payload.size || 'md')">
    <div class="modal-header">
      <h5 class="modal-title"><i :class="icon" v-if="icon"></i> {{ payload.title }}</h5>
    </div>
    <div class="modal-body">
      <div v-html="payload.message"></div>
    </div>
    <div class="modal-footer">
      <button type="button" @click="confirm(option)" v-for="(option, i) in payload.options" :key="i" class="btn btn-sm"
        :class="`btn-${option.variant}`">
        {{ option.label }}
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  watch: {
    visible(val) {
      if (val) this.$refs.modal.show();
      else this.$refs.modal.hide();
    }
  },

  computed: {
    payload() {
      return this.$store.state.confirmation;
    },

    visible() {
      return this.payload.visible;
    },

    icon(){
      if (this.payload.type == 'confirmation') return 'fa-regular fa-circle-question';
      if (this.payload.type == 'info') return 'fa-solid fa-circle-info';
      return '';
    }
  },

  methods: {
    confirmed(value, data) {
      this.payload.events.confirm(value, data);
    },

    close() {
      if (this.visible) {
        this.$store.dispatch('confirmation/close');
        this.confirmed('close', null);
      }
    },

    confirm(opt) {
      if (opt.close === undefined || opt.close) this.$store.dispatch('confirmation/close');
      this.confirmed(opt.name, opt.data);
    }
  },
};
</script>
